import client from './client';

export default {
  all(params) {
    return client.get('/appointments')
      .query(params)
      .end();
  },

  show(params) {
    return client.get(`/appointments/${params.id}`)
      .end();
  },

  cancel(params) {
    return client.post(`/appointments/${params.id}/cancel`)
      .end();
  },

  close(params) {
    return client.post(`/appointments/${params.id}/close`)
      .end();
  },

  open(params) {
    return client.post(`/appointments/${params.id}/re_open`)
      .end();
  },

  confirm(params) {
    return client.post(`/appointments/${params.id}/confirm`)
      .end();
  },

  create(params) {
    return client.post(`/reps/${params.repId}/appointments`)
      .send(params)
      .end();
  },

  update(params) {
    return client.patch(`/appointments/${params.id}`)
      .send(params)
      .end();
  },

  verifyLimit(params) {
    return client.get(`/appointments/${params.id}/verify_limit`)
      .send(params)
      .end();
  }
};



// WEBPACK FOOTER //
// ./app/sources/api/appointmentAPI.js